import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import CustomDatePicker from "./Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import { Modal, Button, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import * as Yup from "yup";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import gearImg from "../../../../assets/gear.png";
import debounce from "lodash.debounce";

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "64px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
};

const CreateProjectEdit = () => {
  const { id } = useParams();
  const timeRef = useRef();

  const initialFormData = {
    ClientID: null,
    Name: "",
    ProjectType: null,
    InvoiceType_73: null,
    ProjectLocation: null,
    Technologies: "",
    StartDate: null,
    ID: "",
    EndDate: null,
    DaysOrMonth: "",
    PaymentTerms: "",
    POValue: "",

    Currency: null,
    FixedBid: null,
    Description: "",
    Rate: "",
    projectinvoice: [
      // {
      //   InvoiceNo: "",
      //   StartDate: null,
      //   EndDate: null,
      //   SoPoValue: null,
      //   SoPoBalance: null,
      //   SoPoRemark: null,
      // },
    ],
    projectmilestone: [],
    projectmember: [
      {
        ID: "",
        EmployeeID: "",
        AllocationPercent: null,
        CompanyID: "",
        BranchID: "",
        ProjectInvoiceDetailID: "",
        FromDate: "",
        ToDate: "",
        ProjectAllocationType_160: null,
        LocationType_237: "",
        InvoiceRate: "",
        IncentiveInAmount: "",
        IncentiveApplicable: "",
        IncentiveInPercent: null,
        ActualEndDate: null,
        DeliveryMode_247: null,
        TrainingType_158: null,
        Role: "",
        TimeZone_88: null,
        FromTime: "",
        ToTime: "",
        POCName: "",
        POCEmail: "",
        POCPhone: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        State: "",
        Country: "",
        ZipCode: "",
        InvoiceBasedOn_236: "",
        DeliveryVersionID: null,
        Location: "",
        RevisionNumber: "",
        TNEInvoice: "0",
        technologyTypeList: null,
        Technology: "",
        IncentiveFrequency_248: null,
      },
    ],
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Project"));
  }, []);

  const [loading, setLoading] = useState(false);
  const [showSOWModal, setShowSOWModal] = useState(false);
  const [showFixedBidModal, setShowFixedBidModal] = useState(false);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);
  const [billableOptions, setBillableOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [fixedBidOptions, setFixedBidOptions] = useState([
    { value: 0, label: "-Select Bid-" },
    { value: 1, label: "Yes" },
  ]);
  const [technoOptions, setTechnologyOptions] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [sowLines, setSowLines] = useState(formData?.projectinvoice);
  const [errors, setErrors] = useState({});
  const [sowErrors, setSowErrors] = useState({}); // Separate state for errors
  const [fixesBidLines, setFixedBidLines] = useState(
    formData?.projectmilestone || []
  );
  const [employeelistOptions, setEmployeeListOptions] = useState([]);

  const [projectInvoiceNoOptions, setProjectInvoiceNoOptions] = useState([]);
  const [locationTypeOptions, setLocationTypeOptions] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [incentiveOptions, setIncentiveOptions] = useState([]);
  const [addResourcesLines, setAddResourcesLines] = useState([]);
  const [sowTypesOptions, setSOWTypesOptions] = useState([]);
  const [milestoneErrors, setMilestoneErrors] = useState({});
  const [disabledIncentiveFields, setDisabledIncentiveFields] = useState({});
  const [clientFetchData, setClientFetchData] = useState([]);
  const [employeeID, setEmployeeID] = useState("");
  const [employeeData, setEmployeeData] = useState([]); // Store multiple employee data
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [selectedEmpID, setSelectedEmpID] = useState(null);
  const [oldResourcesArr, setOldResources] = useState([]);
  const [matchedTechnologyOpt, setMatchedTechnologyOpt] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [deliveryVersionOptions, setDeliveryVersionOptions] = useState([]);
  const [deliveryTypeOptions, setDeliveryTypeOptions] = useState([]);
  const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  const [deliveryModeOptions, setDeliveryModeOptions] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);

  const sowLinesSchema = Yup.object().shape({
    InvoiceNo: Yup.string().required("SOW/PO/SO is required"),
    StartDate: Yup.string().required("Start date is required"),
    EndDate: Yup.string().nullable(), // EndDate can be empty
    SoPoBalance: Yup.string().nullable(), // EndDate can be empty
    SoPoValue: Yup.string().nullable(), // EndDate can be empty
    SoPoRemark: Yup.string().nullable(), // EndDate can be empty
  });

  const milestoneSchema = Yup.object().shape({
    Milestone: Yup.string().required("Milestone number is required"),
  });

  // schema for the consulting
  const schema1 = Yup.object().shape({
    ClientID: Yup.number()
      .typeError("Client is required")
      .required("Client is required"),
    Name: Yup.string().required("Name is Required"),
    ProjectType: Yup.number()
      .typeError("Project Type is required")
      .required("Project Type is required"),
    InvoiceType_73: Yup.number()
      .typeError("Billable is required")
      .required("Billable is required"),
    ProjectLocation: Yup.number()
      .typeError("Location is required")
      .required("Location is required"),

    Technologies: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.number().required("Technology value is required"),
          label: Yup.string().required("Technology label is required"),
        })
      )
      .required("Technologies are required"),

    StartDate: Yup.string().required("Start Date is Required"),
    EndDate: Yup.string().nullable(),
    DaysOrMonth: Yup.string().nullable(),
    PaymentTerms: Yup.string().required("Payment Term is required"),
    POValue: Yup.string().nullable(),
    TNEInvoice: Yup.mixed().nullable(),
    Currency: Yup.number()
      .typeError("Currency is required")
      .required("Currency is required"),
    FixedBid: Yup.number().typeError("Fixed Bid is required").nullable(),
    Description: Yup.string().nullable(),
    Rate: Yup.string().nullable(),
    projectinvoice: Yup.array()
      .of(sowLinesSchema)
      .min(1, "At least one SOW/PO/SO is required"),
    projectmilestone: Yup.array()
      .of(milestoneSchema)
      .when("FixedBid", {
        is: (val) => val === 1,
        then: (schema) => schema.min(1, "At least one milestone is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    projectmember: Yup.array().of(
      Yup.object().shape({
        ID: Yup.string(),
        ProjectID: Yup.string(),
        ProjectInvoiceDetailID: Yup.string().required("SOW/PO/SO is required"),
        TNEInvoice: Yup.string().nullable(),
        AllocationPercent: Yup.number().nullable(),
        EmployeeID: Yup.string().required("Employee is required"),
        Role: Yup.string().required("Role is required"),
        technologyTypeList: Yup.number().when("ProjectType", {
          is: (ProjectType) => formData?.ProjectType == 1528, // Use field value instead of formData
          then: (schema) => schema.nullable(),
          otherwise: (schema) =>
            schema
              .typeError("Technology is required")
              .required("Technology is required"),
        }),
        FromDate: Yup.string().required("From Date is required"),
        ToDate: Yup.string().nullable(),
        Location: Yup.string().required("Location is required"),
        ExtendedTo: Yup.string().nullable(),
        LocationType_237: Yup.string().required("Loc. Type is required"),
        InvoiceRate: Yup.string().nullable(),
        IncentiveInPercent: Yup.number().nullable(),
        IncentiveInAmount: Yup.number()
          .typeError("Qtly Inc. Amt. is required")
          .required("Qtly Inc. Amt. is required"),
        IncentiveApplicable: Yup.number()
          .typeError("Inc. App. is required")
          .required("Inc. App. is required"),
        InvoiceBasedOn_236: Yup.number()
          .typeError("Freq is required")
          .required("Freq is required"),
        ExtendedOn: Yup.mixed().nullable(),
        ActualEndDate: Yup.string().nullable(),
      })
    ),
  });

  // below schema for the Trainers
  const schema2 = Yup.object().shape({
    ClientID: Yup.number()
      .typeError("Client is required")
      .required("Client is required"),
    Name: Yup.string().required("Name is Required"),
    ProjectType: Yup.number()
      .typeError("Project Type is required")
      .required("Project Type is required"),
    InvoiceType_73: Yup.number()
      .typeError("Billable is required")
      .required("Billable is required"),
    ProjectLocation: Yup.number()
      .typeError("Location is required")
      .required("Location is required"),

    Technologies: Yup.mixed().nullable(),
    StartDate: Yup.string("Start Date is Required"),
    // .required("Start Date is Required")
    EndDate: Yup.string().nullable(),
    DaysOrMonth: Yup.string().nullable(),
    PaymentTerms: Yup.string("Payment Term is required").required(
      "Payment Term is required"
    ),
    POValue: Yup.string().nullable(),
    TNEInvoice: Yup.mixed().nullable(),
    Currency: Yup.number()
      .typeError("Currency is required")
      .required("Currency is required"),
    FixedBid: Yup.number().typeError("Fixed Bid is required").nullable(),
    Description: Yup.string().nullable(),
    Rate: Yup.string().nullable(),
    projectinvoice: Yup.array()
      .of(sowLinesSchema)
      .min(1, "At least one SOW/PO/SO is required"),
    projectmilestone: Yup.array()
      .of(milestoneSchema)
      .when("FixedBid", {
        is: (val) => val === 1, // Only validate when FixedBid is exactly 1
        then: (schema) => schema.min(1, "At least one milestone is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    projectmember: Yup.array().of(
      Yup.object().shape({
        ID: Yup.string(),
        ProjectID: Yup.string(),
        ProjectInvoiceDetailID: Yup.string().required("SOW/PO/SO is required"),
        TNEInvoice: Yup.string().nullable(),
        AllocationPercent: Yup.number().nullable(),
        EmployeeID: Yup.string().required("Employee is required"),
        Technology: Yup.string().nullable(),
        POCName: Yup.string().nullable(),
        POCEmail: Yup.string().nullable(),
        POCPhone: Yup.string().nullable(),
        AddressLine1: Yup.string().nullable(),
        State: Yup.string().nullable(),
        ZipCode: Yup.string().nullable(),

        City: Yup.string().nullable(),
        Country: Yup.string().nullable(),
        AddressLine2: Yup.string().nullable(),
        DeliveryVersionID: Yup.number().nullable(),
        DeliveryMode_247: Yup.number().nullable(),
        TrainingType_158: Yup.number()
          .typeError("Type is required")
          .required("Type is required"),
        TimeZone_88: Yup.number().nullable(),
        IncentiveFrequency_248: Yup.number().nullable(),
        FromTime: Yup.string().nullable(),
        ToTime: Yup.string().nullable(),
        // ToDate: Yup.string().required("Start date is required"),
        // FromDate: Yup.string().required("End date is required"),

        InvoiceRate: Yup.string().nullable(),
        FromDate: Yup.string().required("Satrt Date is required"),
        ToDate: Yup.string().required("End Date is required"),
        ActualEndDate: Yup.string().nullable(),

        IncentiveInAmount: Yup.string().nullable(),

        IncentiveInPercent: Yup.number().required(
          "Incentive In Percent is required"
        ),
        InvoiceBasedOn_236: Yup.number()
          .typeError("Freq is required")
          .required("Freq is required"),
      })
    ),
    // .min(1, "At least one project member is required"),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      // Determine which schema to use based on ProjectType
      const currentSchema = [1136, 6958, 6905].includes(formData?.ProjectType) ? schema2 : schema1;

      // Validate the specific field
      await currentSchema.validateAt(fieldName, updatedData);

      // Clear any existing error for this field
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      // Handle validation errors
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));

      // Special handling for projectmember array fields
      if (fieldName.includes("projectmember")) {
        // Use a proper toast/notification system instead of alert
        console.error("Project Member Error:", err.message);
        // Example with toast: toast.error(err.message);
      }
    }
  };

  const validateSowField = async (fieldName, value) => {
    try {
      await sowLinesSchema.validateAt(fieldName, { [fieldName]: value });

      setSowErrors((prevErrors) => {
        const { [fieldName]: _, ...newErrors } = prevErrors; // ✅ Remove error if valid
        return newErrors;
      });
    } catch (err) {
      setSowErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message, // ✅ Store error without index
      }));
      toast.error(err.message, { position: "top-right" });
    }
  };

  const handleSowModal = (e) => {
    e.preventDefault();
    setShowSOWModal(true);
  };
  const handleSOWClose = () => {
    setShowSOWModal(false);
    setSowLines(formData?.projectinvoice);
  };

  const handleFixedBid = (e) => {
    setShowFixedBidModal(true);
    e.preventDefault();
  };

  const handleFixedBidClose = () => {
    setShowFixedBidModal(false);
  };

  useEffect(() => {
    fetchIndexData();
    fetchShowData();
  }, []);

  const handleAddResourceLine = () => {
    const projectMembers = formData.projectmember || []; // Ensure it's an array
    const lastRow =
      projectMembers.length > 0
        ? projectMembers[projectMembers.length - 1]
        : null;

    if (lastRow && !lastRow.EmployeeID) {
      toast.error("Please fill in the current row before adding a new one.", {
        position: "top-right",
      });
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      projectmember: [
        ...projectMembers, // Ensure spreading an existing array
        {
          ID: "",
          isNew: true,
          EmployeeID: "",
          AllocationPercent: null,
          CompanyID: "",
          BranchID: "",
          ProjectInvoiceDetailID: "",
          FromDate: "",
          ToDate: "",
          ProjectAllocationType_160: null,
          LocationType_237: "",
          InvoiceRate: "",
          IncentiveInAmount: "",
          IncentiveApplicable: "",
          IncentiveInPercent: null,
          ActualEndDate: null,
          DeliveryMode_247: null,
          IncentiveFrequency_248: null,
          TrainingType_158: null,
          Role: "",
          TimeZone_88: null,
          FromTime: "",
          ToTime: "",
          POCName: "",
          POCEmail: "",
          POCPhone: "",
          AddressLine1: "",
          AddressLine2: "",
          City: "",
          State: "",
          Country: "",
          ZipCode: "",
          InvoiceBasedOn_236: "",
          DeliveryVersionID: null,
          Location: "",
          RevisionNumber: "",
          TNEInvoice: "0",
          technologyTypeList: null,
          Technology: "",
        },
      ],
    }));
  };

  const fetchIndexData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/project-getdata`
      );

      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const fetchData = response?.data?.data;

        const clientOpt = fetchData?.clientname?.map((ele, inded) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setClientNameOptions(clientOpt);

        const projectTypeOpt = fetchData?.projectallocationtype?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setProjectTypeOptions(projectTypeOpt);

        const billableOpt = fetchData?.billable?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setBillableOptions(billableOpt);
        const locationOpt = fetchData?.locationlist?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setLocationOptions(locationOpt);
        const currenOpt = fetchData?.currency?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setCurrencyOptions(currenOpt);

        const technoOpt = fetchData?.technologylist?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setTechnologyOptions(technoOpt);

        const locTypeOpt = fetchData?.locationtype?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setLocationTypeOptions(locTypeOpt);
        const freqOpt = fetchData?.frequency?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setFrequencyOptions(freqOpt);
        const incentiveOpt = fetchData?.incentiveapp?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setIncentiveOptions(incentiveOpt);
        const proposalOpt = Object.entries(fetchData?.proposal || {}).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );

        setSOWTypesOptions(proposalOpt);
      } else {
        console.error(
          "Failed to fetch asset categories. Server responded with status:",
          response
        );
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const parseSelectedOptions = (dataString, options) => {
    if (!dataString) return [];

    return (Array.isArray(dataString) ? dataString : dataString.split(","))
      .map((id) => options.find((option) => option.value === Number(id)))
      .filter(Boolean);
  };

  const fetchShowData = async () => {
    setPageLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/project-listingdata/${id}`
      );

      SetApiStatus(response?.status);
      if (response?.status === 200) {
        setPageLoading(false);
        const courseOpt = response?.data?.data?.course?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setCourseOptions(courseOpt);
        const empOpt = response?.data?.data?.employeelist?.map(
          (ele, index) => ({
            value: ele?.value,
            label: ele?.text,
          })
        );
        setEmployeeListOptions(empOpt);
        const timeZoneOpt = response?.data?.data?.timezone?.map(
          (ele, index) => ({
            value: ele?.value,
            label: ele?.text,
          })
        );
        setTimeZoneOptions(timeZoneOpt);
        const deliveryTypeOpt = response?.data?.data?.deliverytype?.map(
          (ele, index) => ({
            value: ele?.value,
            label: ele?.text,
          })
        );
        setDeliveryTypeOptions(deliveryTypeOpt);
        const deliverymodeOpt = response?.data?.data?.deliverymode?.map(
          (ele, index) => ({
            value: ele?.value,
            label: ele?.text,
          })
        );
        setDeliveryModeOptions(deliverymodeOpt);
        const projectInvoiceOpt =
          response?.data?.data?.projectInvoiceDetails?.map((ele, index) => ({
            value: ele?.ID,
            label: ele?.InvoiceNo,
          }));
        const matchedTechnologyOpt =
          response?.data?.data?.projectTechnology?.map((ele, index) => ({
            value: ele?.value,
            label: ele?.text,
          }));
        setMatchedTechnologyOpt(matchedTechnologyOpt);

        setProjectInvoiceNoOptions(projectInvoiceOpt);
        const headerData = response?.data?.data?.projectDetails[0];

        const technologyOptions = response?.data?.data?.technology?.map(
          (ele, index) => ({
            value: ele?.value,
            label: ele?.text,
          })
        );

        // Set selected skills and sub-skills
        const selectedTechnologies = parseSelectedOptions(
          headerData?.Technology,
          technologyOptions
        );

        let oldresArr = [];
        let newresArr = [];

        response?.data?.data?.projectmember?.map((o) => {
          const endDate =
            o.ActualEndDate && o.ActualEndDate !== "" ? o.ActualEndDate : "";

          if (moment(endDate).isBefore(moment(), "day")) {
            oldresArr.push(o);
          } else {
            newresArr.push(o);
          }
        });
        setOldResources(oldresArr);
        setFormData((prevState) => ({
          ...prevState,
          ClientID: headerData?.ClientID,
          Name: headerData?.Name,
          ID: headerData?.ID,
          ProjectType: headerData?.ProjectAllocationType_160,
          InvoiceType_73: headerData?.InvoiceType_73,
          ProjectLocation: headerData?.ProjectLocationMasterID,
          Technologies: selectedTechnologies, // Ensure this updates correctly
          StartDate: headerData?.StartDate || null,
          EndDate: headerData?.EndDate || null,
          DaysOrMonth: headerData?.DaysOrMonth,
          PaymentTerms: headerData?.PaymentTerms,
          POValue: headerData?.POValue,
          // TNEInvoice: headerData?.TNEInvoice,
          Currency: headerData?.CurrencyID,
          FixedBid: headerData?.FixedBid || null,
          Description: headerData?.Description,
          Rate: headerData?.InvoiceRate,
          projectinvoice: response?.data?.data?.projectInvoiceDetails,
          projectmilestone: response?.data?.data?.projectMilestoneDetails,
          projectmember: newresArr?.map((o) => ({
            ...o,
            Technology: o.Technology || "",
          })),
        }));
        setSowLines(response?.data?.data?.projectInvoiceDetails);
        setFixedBidLines(response?.data?.data?.projectMilestoneDetails);
        setAddResourcesLines(response?.data?.data?.projectmember);
      } else {
        console.error(
          "Failed to fetch asset categories. Server responded with status:",
          response
        );
      }
    } catch (error) {
      console.error("Fecthing Api error", error);
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // Update form data only for fields in the schema
    const currentSchema = [1136, 6958, 6905].includes(formData?.ProjectType) ? schema2 : schema1;
    if (currentSchema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        validateField(name, updatedData);
        return updatedData;
      });
    }
  };

  const handleSelectChange = async (selectedOption, name) => {
    // Update formData with the selected value for the SkillID
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };

  const handleFixedBidAddLine = () => {
    if (
      fixesBidLines.length === 0 ||
      fixesBidLines[fixesBidLines.length - 1].Milestone?.trim()
    ) {
      setFixedBidLines((prevLines) => [
        ...prevLines,
        {
          LineNo: prevLines.length + 1,
          ID: null,
          Milestone: null,
          StartDate: "",
          EndDate: "",
          Remarks: "",
          MilestoneValue: 0,
        },
      ]);
    } else {
      toast.error("Milestone is required before adding a new line.", {
        position: "top-right",
      });
    }
  };

  const handleMileStoneChange = async (e, index) => {
    const { name, value } = e.target;

    setFixedBidLines((prevLines) =>
      prevLines.map((row, idx) =>
        idx === index ? { ...row, [name]: value } : row
      )
    );

    if (name === "Milestone") {
      await validateMilestoneField(value, index);
    }
  };

  const validateMilestoneField = async (value, index) => {
    try {
      await milestoneSchema.validate({ Milestone: value });

      setMilestoneErrors((prevErrors) => {
        const { [`Milestone - ${index}`]: _, ...newErrors } = prevErrors;
        return newErrors;
      });
    } catch (error) {
      setMilestoneErrors((prevErrors) => ({
        ...prevErrors,
        [`Milestone - ${index}`]: error.message,
      }));
      toast.error(error.message, { position: "top-right" });
    }
  };

  const addMilestoneToInvoice = async () => {
    if (fixesBidLines.length === 0) {
      toast.error("At least one milestone record is required before saving.", {
        position: "top-right",
      });
      return;
    }

    try {
      await Promise.all(
        fixesBidLines.map((row) =>
          milestoneSchema.validate(row, { abortEarly: false })
        )
      );

      setMilestoneErrors({});
      setShowFixedBidModal(false);

      setFormData((prevFormData) => ({
        ...prevFormData,
        projectmilestone: fixesBidLines,
      }));
    } catch (error) {
      if (error.inner) {
        const newErrors = error.inner.reduce((acc, err) => {
          acc[err.path] = err.message;
          return acc;
        }, {});

        setMilestoneErrors(newErrors);
      }
    }
  };

  const handleDeleteMilestoneLine = (index) => {
    setFixedBidLines((prevLines) =>
      prevLines.filter((_, idx) => idx !== index)
    );

    setMilestoneErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`Milestone`];
      return newErrors;
    });
  };

  const handleDeleteAddResource = async (index) => {
    const updatedLines = formData.projectmember.filter((_, i) => i !== index);
    setFormData((prevState) => ({
      ...prevState,
      projectmember: updatedLines,
    }));
  };

  const handleSowAddLine = () => {
    if (
      sowLines.length === 0 ||
      (sowLines[sowLines.length - 1].InvoiceNo.trim() &&
        sowLines[sowLines.length - 1].StartDate)
    ) {
      setSowLines((prevSowLines) => [
        ...prevSowLines,
        {
          LineNo: prevSowLines.length + 1,
          InvoiceNo: "",
          StartDate: null,
          EndDate: null,
          ID: null,
          SoPoValue: null,
          SoPoBalance: null,
          SoPoRemark: null,
        },
      ]);
    } else {
      toast.error(
        "Invoice No. and Start Date are required before adding a new line.",
        { position: "top-right" }
      );
    }
  };

  const handleProjectInvoiceChange = async (e, index) => {
    const { name, value } = e.target;

    setSowLines((prevSowLines) =>
      prevSowLines.map((row, idx) =>
        idx === index ? { ...row, [name]: value } : row
      )
    );

    if (["InvoiceNo", "StartDate"].includes(name)) {
      await validateSowField(name, value);
    }
  };

  const handleProjectInvoiceSelectChange = async (
    selectedOption,
    name,
    index
  ) => {
    // Format the current date as DD-MM-YYYY
    const now = new Date();
    const formattedDate = moment(now).format("DDMMMYYYY");

    setSowLines((prevSowLines) => {
      // Count how many SOW entries exist already
      const currentSowCount = prevSowLines.filter((line) =>
        line.InvoiceNo?.startsWith("SOW")
      ).length;

      return prevSowLines.map((row, idx) =>
        idx === index
          ? {
              ...row,
              [name]: selectedOption?.value,
              InvoiceNo:
                selectedOption?.label === "SOW"
                  ? `SOW_${formattedDate}_${currentSowCount + 1}`
                  : "",
            }
          : row
      );
    });

    if (["ProposalType"].includes(name)) {
      await validateSowField("InvoiceNo", selectedOption?.label);
    }
  };

  const AddSowToInvoice = async () => {
    if (sowLines.length === 0) {
      toast.error("At least one record is required before saving.", {
        position: "top-right",
      });
      return;
    }

    try {
      await Promise.all(
        sowLines.map((row) =>
          sowLinesSchema.validate(row, { abortEarly: false })
        )
      );

      setSowErrors({});
      setShowSOWModal(false);
      // toast.success("All fields are valid!", { position: "top-right" });

      setFormData((prevFormData) => ({
        ...prevFormData,
        StartDate: sowLines?.length ? sowLines[0].StartDate : null,
        EndDate: sowLines?.length
          ? sowLines[sowLines.length - 1].EndDate
          : null,
        projectinvoice: sowLines,
      }));
      validateField("projectinvoice", sowLines);
    } catch (error) {
      if (error.inner) {
        const newErrors = error.inner.reduce((acc, err) => {
          if (err.path && ["InvoiceNo", "StartDate"].includes(err.path)) {
            acc[err.path] = err.message;
          }
          return acc;
        }, {});

        setSowErrors(newErrors);
      }
    }
  };

  const handleDeleteLine = (index) => {
    setSowLines((prevSowLines) =>
      prevSowLines.filter((_, idx) => idx !== index)
    );

    setSowErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors["InvoiceNo"];
      delete newErrors["StartDate"];
      return newErrors;
    });
  };

  const handleTechnologyChange = async (selectedOptions) => {
    const selectedTechnologies = selectedOptions || [];

    // Prepare updated form data with new Technologies
    const updatedFormData = {
      ...formData,
      Technologies: selectedTechnologies,
    };

    setFormData(updatedFormData);

    // Call validateField with correct updated data
    validateField("Technologies", updatedFormData);
  };

  const handleResourceSelect = async (selectedOption, index, name) => {
    let incentivePercentage =
      formData.projectmember[index]?.IncentiveInPercent || null;

    if (name === "IncentiveApplicable") {
      try {
        let response = await GetServiceCaller(
          `${API_URL}projectmanagement/project-getincentive?IncentiveID=${selectedOption?.value}`
        );

        if (
          response?.status === 200 &&
          Array.isArray(response?.data?.data) &&
          response?.data?.data.length > 0
        ) {
          incentivePercentage = response?.data?.data[0]?.Percent || 0;
          setDisabledIncentiveFields((prev) => ({ ...prev, [index]: true }));
        } else {
          setDisabledIncentiveFields((prev) => ({ ...prev, [index]: false }));
        }
      } catch (error) {
        console.error("Fetching Error", error);
        setDisabledIncentiveFields((prev) => ({ ...prev, [index]: false }));
      }
    }

    setFormData((prev) => {
      const updatedLines = [...prev.projectmember];
      updatedLines[index] = {
        ...updatedLines[index],
        [name]: selectedOption.value,
        IncentiveInPercent: incentivePercentage,
      };

      return { ...prev, projectmember: updatedLines };
    });

    await validateField(`projectmember[${index}].${name}`, {
      ...formData,
      projectmember: formData.projectmember.map((member, idx) =>
        idx === index ? { ...member, [name]: selectedOption.value } : member
      ),
    });
  };

  const handleResourceChange = async (e, index) => {
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? (checked ? "1" : "0") : value;

    setFormData((prevState) => {
      const updatedLines = [...prevState.projectmember];
      updatedLines[index] = {
        ...updatedLines[index],
        [name]: newValue,
      };

      const updatedFormData = { ...prevState, projectmember: updatedLines };

      // Validate field after state update
      validateField(`projectmember[${index}].${name}`, updatedFormData);

      return updatedFormData;
    });
  };

  // Enhanced submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const currentSchema = [1136, 6958, 6905].includes(formData?.ProjectType) ? schema2 : schema1;

      // Validate with better error handling
      await currentSchema.validate(formData, {
        abortEarly: false,
        stripUnknown: true,
      });
      setErrors({});

      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/project-listingdata/${id}`,
        formData,
        "put"
      );

      if (response?.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => window.location.reload(), 2000);
      } else {
        console.error(response?.data?.message);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);

        const validationErrors = {};
        error.inner?.forEach((err) => {
          validationErrors[err.path] = err.message;
          toast.error(err.message);
        });

        setErrors(validationErrors);

        // Show the first error without spamming
        if (error.inner[0]?.message) {
          console.error(`Validation error: ${error.inner[0].message}`);
        }
      } else {
        console.error("Submission error:", error);
        toast.error(
          error.response?.data?.message ||
            "Something went wrong. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployeeDetails = async (id) => {
    if (!id) return; // Prevent unnecessary API calls

    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/employee-project-details?employeeID=${id}`
      );

      if (response?.status === 200 && response.data) {
        setEmployeeData((prevData) => {
          const existingIndex = prevData.findIndex(
            (emp) => emp.EmployeeID === id
          );
          const newData = { ...response.data, EmployeeID: id }; // Ensure new object is stored

          if (existingIndex !== -1) {
            const updatedData = [...prevData];
            updatedData[existingIndex] = newData; // Update existing entry
            return updatedData;
          }
          return [...prevData, newData]; // Append new data
        });
        // setSelectedEmpID(id);
      }
    } catch (error) {
      console.error("Fetching error:", error);
    }
  };

  useEffect(() => {
    fetchCourseDetails();
  }, []);

  const fetchCourseDetails = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/course-getdata`
      );

      if (response?.status === 200 && response.data) {
        const deliverytypeOpt =
          response?.data?.versionlist?.map((ele) => ({
            value: ele?.VALUE,
            label: ele?.TEXT,
            MASTER: ele?.MASTER,
          })) || [];

        setDeliveryVersionOptions(deliverytypeOpt);
      }
    } catch (error) {
      console.error("Fetching error:", error);
    }
  };

  useEffect(() => {
    if (selectedEmpID != null) {
      setShowProjectModal(true);
    }
  }, [selectedEmpID]);

  const handleProjectModal = (empID) => {
    setShowProjectModal(true);
    setSelectedEmpID(empID);
  };
  const handleProjectModalClose = () => {
    setShowProjectModal(false);
  };

  useEffect(() => {
    if (formData?.ClientID) {
      fetchClientDetails(formData?.ClientID);
    }
  }, [formData?.ClientID]);

  const fetchClientDetails = async (clientid) => {
    try {
      let response = await GetServiceCaller(
        `${API_URL}projectmanagement/employee-client-details?clientID=${clientid}`
      );

      if (response?.status === 200) {
        setClientFetchData(response?.data?.data);
      }
    } catch (error) {
      console.error("FEtching APi  Error ", error);
    }
  };

  // Add this state to your component
  const [editingIndex, setEditingIndex] = useState(null);

  const handleResourceEdit = (index) => {
    // If clicking the same row that's already in edit mode, exit edit mode
    if (editingIndex === index) {
      setEditingIndex(null);
    } else {
      // Otherwise, set the clicked row to edit mode
      setEditingIndex(index);
    }
  };

  const tdRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tdRef.current && !tdRef.current.contains(event.target)) {
        setEditingIndex(null); // Reset on outside click
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingIndex]);

  const allocationPercentOptions = Array.from({ length: 20 }, (_, i) => {
    const value = (i + 1) * 5;
    return {
      value: value,
      label: `${value}%`,
    };
  });

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div className="Container  " style={{ zoom: 0.7 }}>
        <form
          onSubmit={handleSubmit}
          id="formOne"
          className="rounded mt-2 bg-white"
        >
          {/** Tab Code Start */}
          <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                style={{ color: "#2F2E4B" }}
                id="projectDetails-tab"
                data-bs-toggle="tab"
                data-bs-target="#projectDetails"
                type="button"
                role="tab"
                aria-controls="projectDetails"
                aria-selected="true"
              >
                Project Details
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                style={{ color: "#2F2E4B" }}
                id="addresource-tab"
                data-bs-toggle="tab"
                data-bs-target="#addresource"
                type="button"
                role="tab"
                aria-controls="addresource"
                aria-selected="false"
              >
                {[1136, 6958, 6905].includes(formData?.ProjectType)
                  ? "Add Trainers"
                  : " Add Resource"}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                style={{ color: "#2F2E4B" }}
                id="oldResources-tab"
                data-bs-toggle="tab"
                data-bs-target="#oldResources"
                type="button"
                role="tab"
                aria-controls="oldResources"
                aria-selected="false"
              >
                InActive Resource
              </button>
            </li>
          </ul>
          {/** Tab Code End */}
          <div
            className="tab-content"
            id="myTabContent"
            style={{
              // height: "auto",
              // overflowY: "auto",
              position: "relative",
              paddingBottom: "0", // Remove any default padding
            }}
          >
            {/** Main Form Code start */}
            <div
              className="tab-pane fade show active p-2"
              id="projectDetails"
              role="tabpanel"
              aria-labelledby="projectDetails-tab"
            >
              <div className="row mt-2">
                <div className="col-2">
                  <label className="form-label">
                    Client<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="ClientID"
                    className={` ${errors.ClientID ? "is-invalid" : ""}`}
                    onChange={(selectedOption, action) => {
                      handleSelectChange(selectedOption, action.name);
                      // fetchClientDetails(selectedOption.value);
                    }}
                    value={clientNameOptions?.find(
                      (o) => o.value === formData?.ClientID
                    )}
                    options={clientNameOptions}
                  />
                  {errors.ClientID && (
                    <div className="invalid-feedback">{errors.ClientID}</div>
                  )}
                </div>
                <div className="col-2">
                  <label className="form-label">CP</label>
                  <input
                    type="text"
                    className="form-control"
                    name="CP"
                    disabled
                    value={clientFetchData[0]?.CP_Name}
                  />
                </div>
                <div className="col-2">
                  <label className="form-label">DP</label>
                  <input
                    type="text"
                    className="form-control"
                    name="DP"
                    disabled
                    value={clientFetchData[0]?.DP_Name}
                  />
                </div>
                <div className="col-2">
                  <label className="form-label">PM</label>
                  <input
                    type="text"
                    className="form-control"
                    name="PM"
                    disabled
                    value={clientFetchData[0]?.PM_Name}
                  />
                </div>

                <div className="col-2">
                  <label className="form-label">
                    Project Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    disabled={formData.projectmember.length > 0}
                    className={`form-control ${
                      errors.Name ? "is-invalid" : ""
                    }`}
                    name="Name"
                    value={formData?.Name}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.Name && (
                    <div className="invalid-feedback">{errors.Name}</div>
                  )}
                </div>
                <div className="col-2">
                  <label className="form-label">
                    Project Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="ProjectType"
                    className={` ${errors.ProjectType ? "is-invalid" : ""}`}
                    onChange={(selectedOption, action) =>
                      handleSelectChange(selectedOption, action.name)
                    }
                    value={projectTypeOptions?.find(
                      (o) => o.value === formData?.ProjectType
                    )}
                    options={projectTypeOptions}
                  />
                  {errors.ProjectType && (
                    <div className="invalid-feedback">{errors.ProjectType}</div>
                  )}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-2">
                  <label className="form-label">
                    Billable<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="InvoiceType_73"
                    className={` ${errors.InvoiceType_73 ? "is-invalid" : ""}`}
                    onChange={(selectedOption, action) =>
                      handleSelectChange(selectedOption, action.name)
                    }
                    value={billableOptions?.find(
                      (o) => o.value === formData?.InvoiceType_73
                    )}
                    options={billableOptions}
                  />
                  {errors.InvoiceType_73 && (
                    <div className="invalid-feedback">
                      {errors.InvoiceType_73}
                    </div>
                  )}
                </div>
                <div className="col-2">
                  <label className="form-label">
                    Location<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="ProjectLocation"
                    className={` ${errors.ProjectLocation ? "is-invalid" : ""}`}
                    onChange={(selectedOption, action) =>
                      handleSelectChange(selectedOption, action.name)
                    }
                    value={locationOptions?.find(
                      (o) => o.value === formData?.ProjectLocation
                    )}
                    options={locationOptions}
                  />
                  {errors.ProjectLocation && (
                    <div className="invalid-feedback">
                      {errors.ProjectLocation}
                    </div>
                  )}
                </div>
                <div className="col-2">
                  <label className="form-label">
                    Technology<span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti
                    className={` ${errors.Technologies ? "is-invalid" : ""}`}
                    name="Technologies"
                    options={technoOptions}
                    value={formData?.Technologies}
                    styles={customStyle}
                    onChange={handleTechnologyChange}
                  />
                  {errors.Technologies && (
                    <div className="invalid-feedback">
                      {errors.Technologies}
                    </div>
                  )}
                </div>
                <div className="col-2">
                  <label className="form-label">Fixed bid</label>
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "2px" }}
                  >
                    <div className="col-10">
                      <Select
                        name="FixedBid"
                        className={`${
                          errors.projectmilestone ? "is-invalid" : ""
                        }`}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(selectedOption, action.name)
                        }
                        value={fixedBidOptions?.find(
                          (o) => o.value === formData?.FixedBid
                        )}
                        isDisabled={formData.projectmember.length > 0}
                        options={fixedBidOptions}
                        styles={{
                          control: (base) => ({ ...base, height: "38px" }),
                        }}
                      />
                      {errors.projectmilestone && (
                        <div className="invalid-feedback">
                          {errors.projectmilestone}
                        </div>
                      )}
                    </div>
                    <span className="col-2 text-center">
                      <button
                        type="button"
                        id="Add-btn"
                        className="btn btn-primary"
                        // disabled={formData?.FixedBid === 1 || formData.projectmember.length > 0}
                        style={{ height: "30px", width: "100%" }}
                        onClick={(e) => handleFixedBid(e)}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </span>
                  </div>
                </div>
                {/* <div className='col-2'>
                                            <label className='form-label'>Consolidated</label>
                                            <Select
                                                name="Location"
                                                onChange={(selectedOption, action) => handleSelectChange(selectedOption, action.name)}
                                                        value={consolidatedOptions?.find(o => o.value === formData?.ProjectLocation)}
                                                       
                                                options={consolidatedOptions}
                                            />

                                        </div> */}
                <div className="col-2">
                  <label className="form-label">
                    SOW/PO/SO<span className="text-danger">*</span>
                  </label>
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "2px" }}
                  >
                    <span className="col-2 text-center">
                      <button
                        id="Add-btn"
                        className="custom-btn"
                        style={{ height: "30px", width: "100%" }}
                        onClick={(e) => handleSowModal(e)}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </span>
                    <div className="col-10">
                      <input
                        type="text"
                        disabled
                        name="projectinvoice"
                        value={
                          formData?.projectinvoice?.length
                            ? formData.projectinvoice[
                                formData.projectinvoice.length - 1
                              ].InvoiceNo
                            : null
                        }
                        className={`form-control ${
                          errors.projectinvoice ? "is-invalid" : ""
                        }`}
                      />{" "}
                      {errors.projectinvoice && (
                        <div className="invalid-feedback">
                          {errors.projectinvoice}
                        </div>
                      )}
                    </div>
                  </div>
                </div>{" "}
                <div className="col-2">
                  <label className="form-label">Days/Month</label>
                  <input
                    type="text"
                    disabled
                    name="DaysOrMonth"
                    className="form-control"
                    value={formData?.DaysOrMonth}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-2">
                  <label className="form-label">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <CustomDatePicker
                    // handleChange={(e) => handleChange(e)}
                    value={
                      formData?.StartDate
                        ? moment(formData?.StartDate).format("DD-MMM-YYYY")
                        : null
                    }
                    name="StartDate"
                    className={`form-control ${
                      errors.StartDate ? "is-invalid" : ""
                    }`}
                    readOnly={true}
                    placeholderText="DD-MMM-YYYY"
                  />
                  {errors.StartDate && (
                    <div className="text-danger">{errors.StartDate}</div>
                  )}
                </div>
                <div className="col-2">
                  <label className="form-label">End Date</label>
                  <CustomDatePicker
                    handleChange={(e) => handleChange(e)}
                    value={
                      (formData?.EndDate &&
                        moment(formData?.EndDate).format("DD-MMM-YYYY")) ||
                      null
                    }
                    name="EndDate"
                    readOnly={true}
                    className="form-control"
                    placeholderText="DD-MMM-YYYY"
                  />
                </div>

                <div className="col-2">
                  <label className="form-label">
                    Payment Terms<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    disabled={formData.projectmember.length > 0}
                    className={` form-control ${
                      errors.PaymentTerms ? "is-invalid" : ""
                    }`}
                    name="PaymentTerms"
                    value={formData?.PaymentTerms}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.PaymentTerms && (
                    <div className="invalid-feedback">
                      {errors.PaymentTerms}
                    </div>
                  )}
                </div>
                {/* <div className="col-2">
                <label className="form-label">PO Value {formData?.FixedBid?<span className="error">*</span>:null}</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData?.POValue}
                  name="POValue"
                  onChange={(e) => handleChange(e)}
                  disabled={!formData?.FixedBid}
                />
              </div> */}
                {/* <div className="col-2">
                <label className="form-label">TnE Invoice</label>
                <Select
                  options={tneInvoiceOptions}
                  name="TNEInvoice"
                  value={tneInvoiceOptions?.find(
                    (o) => o.TNEInvoice === formData?.TNEInvoice
                  )}
                  onChange={(selectedOption, action) =>
                    handleSelectChange(selectedOption, action.name)
                  }
                />
              </div> */}
                <div className="col-2">
                  <label className="form-label">
                    Currency<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="Currency"
                    className={` ${errors.Currency ? "is-invalid" : ""}`}
                    onChange={(selectedOption, action) =>
                      handleSelectChange(selectedOption, action.name)
                    }
                    value={currencyOptions?.find(
                      (o) => o.value === formData?.Currency
                    )}
                    options={currencyOptions}
                  />
                  {errors.Currency && (
                    <div className="invalid-feedback">{errors.Currency}</div>
                  )}
                </div>
                <div className="col-2">
                  <label className="form-label">Description</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData?.Description}
                    name="Description"
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                {/* <div className="col-2">
                <label className="form-label">Rate</label>
                <input
                  type="text"
                  className="form-control text-end"
                  // value={}
                  name="Rate"
                  value={formData?.Rate}
                  onChange={(e) => handleChange(e)}
                  // disabled
                />
              </div> */}
              </div>
            </div>
            {/** For consulting and Trainers */}
            {[1136, 6958, 6905].includes(formData?.ProjectType) ? (
              <div
                className="tab-pane  fade show  p-2"
                id="addresource"
                role="tabpanel"
                aria-labelledby="addresource-tab"
              >
                <div className="mt-2" style={{ zIndex: "-999 !important" }}>
                  <div
                    style={{
                      overflowX: "auto", // Enables horizontal scrolling
                      whiteSpace: "nowrap", // Prevents text from wrapping
                      maxWidth: "100%", // Ensures it does not exceed the container width
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                      <div className="d-flex flex-wrap align-items-center gap-3">
                        {/* Client Info */}
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            Client:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientNameOptions?.find(
                                  (o) => o.value === formData?.ClientID
                                )?.label || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={
                                clientNameOptions?.find(
                                  (o) => o.value === formData?.ClientID
                                )?.label || "N/A"
                              }
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        {/* Contact Points */}
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">CP:</label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.CP_Name || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.CP_Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">DP:</label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.DP_Name || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.DP_Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">PM:</label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.PM_Name || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.PM_Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            RMG POC:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.ROMPOCName || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.ROMPOCName || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        {/* Project Info */}
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            Project Name:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>{formData?.Name || "N/A"}</Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={formData?.Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            Project Type:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {projectTypeOptions?.find(
                                  (o) => o.value === formData?.ProjectType
                                )?.label || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={
                                projectTypeOptions?.find(
                                  (o) => o.value === formData?.ProjectType
                                )?.label || "N/A"
                              }
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>
                      </div>

                      {/* Add Button */}
                      <div className="d-flex align-items-center">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip> Add Training</Tooltip>}
                        >
                          <button
                            type="button"
                            onClick={handleAddResourceLine}
                            className="custom-btn mt-4 pull-right"
                          >
                            <i className="fa fa-plus"></i> Add
                          </button>
                        </OverlayTrigger>
                      </div>
                    </div>
                    <div className="table-responsive poc-head rounded px-0">
                      <Table
                        style={{
                          background: "#ECECEC",
                          height: "200px",
                          // minWidth: "1200px", // Set a minimum width to ensure the table is scrollable
                        }}
                        className="table table-bordered"
                      >
                        <thead id="thcolor" className="sticky-thead">
                          <tr className="text-center">
                            <th>Sr. No.</th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                SOW/PO/SO #
                                <span className="text-danger">*</span>
                              </div>
                              <div>Allocation</div>
                            </th>

                            <th>
                              Employee<span className="text-danger">*</span>
                            </th>
                            <th>
                              Course<span className="text-danger">*</span>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Delivery Version
                              </div>
                              <div className="border-1 border-bottom">
                                Delivery Mode
                              </div>
                              <div>
                                Type<span className="text-danger">*</span>
                              </div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Time Zone
                              </div>
                              <div className="border-1 border-bottom">
                                From Time
                              </div>
                              <div>To Time</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Start Date
                                <span className="text-danger">*</span>
                              </div>
                              <div className="border-1 border-bottom">
                                End Date<span className="text-danger">*</span>
                              </div>
                              <div>Act. End</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Invoice Rate
                              </div>
                              <div className="border-1 border-bottom">
                                Freq<span className="text-danger">*</span>
                              </div>
                              <div>{`     `}</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Inc. %<span className="text-danger">*</span>
                              </div>
                              <div className="border-1 border-bottom">
                                Incentive
                              </div>
                              <div>Inc.Frequency</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                POC Name
                              </div>
                              <div className="border-1 border-bottom">
                                POC Email{" "}
                              </div>
                              <div>POC Phone </div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Address 1
                              </div>
                              <div className="border-1 border-bottom">City</div>
                              <div>Country</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Address 2
                              </div>
                              <div className="border-1 border-bottom">
                                State
                              </div>
                              <div>Zip Code</div>
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData?.projectmember?.map((ele, index) => (
                            <tr className="text-center" key={index}>
                              {/** Sr NO */}
                              <td
                                className="text-center"
                                style={{ minWidth: "50px" }}
                              >
                                {index + 1}
                              </td>
                              {/** Sow So PO */}
                              <td
                                style={{ minWidth: "130px" }}
                                className="text-center align-middle"
                              >
                                <div className="d-flex flex-column align-items-center gap-1">
                                  {/* Select Dropdown for ProjectInvoiceDetailID */}
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "ProjectInvoiceDetailID",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column ===
                                      "ProjectInvoiceDetailID" ? (
                                      <Select
                                        name="ProjectInvoiceDetailID"
                                        value={projectInvoiceNoOptions?.find(
                                          (o) =>
                                            o.value ===
                                            ele?.ProjectInvoiceDetailID
                                        )}
                                        placeholder="Select SOW/PO/SO"
                                        options={projectInvoiceNoOptions}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );
                                          setEditingIndex(null);
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        className={`${
                                          errors?.[
                                            `projectmember[${index}].ProjectInvoiceDetailID`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "200px",
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <div className="p-2 w-100 text-center">
                                        {projectInvoiceNoOptions?.find(
                                          (o) =>
                                            o.value ===
                                            ele?.ProjectInvoiceDetailID
                                        )?.label || "Select SOW"}
                                      </div>
                                    )}

                                    {errors?.[
                                      `projectmember[${index}].ProjectInvoiceDetailID`
                                    ] && (
                                      <div className="error text-danger small">
                                        {
                                          errors[
                                            `projectmember[${index}].ProjectInvoiceDetailID`
                                          ]
                                        }
                                      </div>
                                    )}
                                  </div>

                                  {/* Select Dropdown for AllocationPercent */}
                                  {/**<div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "AllocationPercent",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column ===
                                      "AllocationPercent" ? (
                                      <Select
                                        name="AllocationPercent"
                                        value={allocationPercentOptions?.find(
                                          (o) =>
                                            o.value === ele?.AllocationPercent
                                        )}
                                        placeholder="Select Percentage"
                                        options={allocationPercentOptions}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );
                                          setEditingIndex(null);
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        className={`${
                                          errors?.[
                                            `projectmember[${index}].AllocationPercent`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "200px",
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <div className="p-2 w-100 text-center">
                                        {allocationPercentOptions?.find(
                                          (o) =>
                                            o.value === ele?.AllocationPercent
                                        )?.label || "Select Percentage"}
                                      </div>
                                    )}
                                  </div>*/}
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "AllocationPercent",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column ===
                                      "AllocationPercent" ? (
                                      <Select
                                        name="AllocationPercent"
                                        value={allocationPercentOptions?.find(
                                          (o) =>
                                            o.value === ele?.AllocationPercent
                                        )}
                                        placeholder="Utilization Percentage"
                                        options={allocationPercentOptions}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );
                                          setEditingIndex(null);
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        className={`${
                                          errors?.[
                                            `projectmember[${index}].AllocationPercent`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "100px",
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <a
                                        className="p-2 w-100 text-center"
                                        style={{ textDecoration: "none" }}
                                      >
                                        {allocationPercentOptions?.find(
                                          (o) =>
                                            o.value === ele?.AllocationPercent
                                        )?.label || "Utilization Percentage"}
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </td>
                              {/** Employee */}
                              <td
                                style={{ minWidth: "160px" }}
                                className="text-center align-middle"
                              >
                                <div className="d-flex flex-column align-items-center">
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "EmployeeID",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column === "EmployeeID" ? (
                                      <Select
                                        className={`mb-1 ${
                                          errors?.[
                                            `projectmember[${index}].EmployeeID`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        placeholder={"Select Employee"}
                                        name="EmployeeID"
                                        options={employeelistOptions}
                                        value={employeelistOptions?.find(
                                          (o) => o.value === ele?.EmployeeID
                                        )}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );
                                          setSelectedEmpID(
                                            selectedOption.value
                                          );
                                          fetchEmployeeDetails(
                                            selectedOption.value
                                          );
                                          setEditingIndex(null); // Close editor after selection
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "200px",
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <div className=" text-center">
                                        {employeelistOptions?.find(
                                          (o) => o.value === ele?.EmployeeID
                                        )?.label || "Select Employee"}
                                      </div>
                                    )}
                                  </div>
                                  {errors?.[
                                    `projectmember[${index}].EmployeeID`
                                  ] && (
                                    <span className="error text-danger small">
                                      {
                                        errors?.[
                                          `projectmember[${index}].EmployeeID`
                                        ]
                                      }
                                    </span>
                                  )}

                                  {/* Ongoing Projects link (unchanged) */}
                                  <div>
                                    <a
                                      href="#"
                                      style={{ textDecoration: "none" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleProjectModal(ele?.EmployeeID);
                                        fetchEmployeeDetails(ele?.EmployeeID);
                                      }}
                                    >
                                      Ongoing Projects
                                    </a>
                                  </div>
                                </div>
                              </td>
                              {/** Course */}
                              <td
                                style={{ minWidth: "160px" }}
                                className="text-center align-middle"
                              >
                                <div className="d-flex flex-column align-items-center">
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "Technology",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column === "Technology" ? (
                                      <Select
                                        className={`mb-1 ${
                                          errors?.[
                                            `projectmember[${index}].Technology`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        placeholder={"Select Course"}
                                        name="Technology"
                                        options={courseOptions}
                                        value={courseOptions?.find(
                                          (o) =>
                                            o.value === Number(ele?.Technology)
                                        )}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );

                                          setEditingIndex(null); // Close editor after selection
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "200px",
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <div className=" text-center">
                                        {courseOptions?.find(
                                          (o) =>
                                            o.value === Number(ele?.Technology)
                                        )?.label || "Select Course"}
                                      </div>
                                    )}
                                  </div>
                                  {errors?.[
                                    `projectmember[${index}].Technology`
                                  ] && (
                                    <span className="error text-danger small">
                                      {
                                        errors?.[
                                          `projectmember[${index}].Technology`
                                        ]
                                      }
                                    </span>
                                  )}
                                </div>
                              </td>
                              {/** version mode type */}
                              <td style={{ minWidth: "140px" }}>
                                <div className="mb-1">
                                  <Select
                                    className={`mb-1 ${
                                      errors?.[
                                        `projectmember[${index}].DeliveryVersionID`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder={"Select Course"}
                                    name="DeliveryVersionID"
                                    options={deliveryVersionOptions.filter(
                                      (o) => o.MASTER == ele?.Technology
                                    )}
                                    value={deliveryVersionOptions?.find(
                                      (o) => o.value === ele?.DeliveryVersionID
                                    )}
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption, action) => {
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      );
                                    }}
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "32px",
                                        height: "32px",
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                                <div className="mt-1">
                                  <Select
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].DeliveryMode_247`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Select Technology"
                                    options={deliveryModeOptions}
                                    value={deliveryModeOptions?.find(
                                      (o) => o.value === ele?.DeliveryMode_247
                                    )}
                                    name="DeliveryMode_247"
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                                <div className="mt-1">
                                  <Select
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].TrainingType_158`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Select Technology"
                                    options={deliveryTypeOptions}
                                    value={deliveryTypeOptions?.find(
                                      (o) => o.value === ele?.TrainingType_158
                                    )}
                                    name="TrainingType_158"
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].TrainingType_158`
                                  ] ? (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].TrainingType_158`
                                        ]
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>

                              {/** zon fom to time */}

                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <Select
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].TimeZone_88`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Select TmeZone"
                                    options={timeZoneOptions}
                                    value={timeZoneOptions?.find(
                                      (o) =>
                                        o.value === Number(ele?.TimeZone_88)
                                    )}
                                    name="TimeZone_88"
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                                <div className="mt-1">
                                  {/* <TimePicker  name="InterviewTime"  /> */}
                                  <input
                                    type="time"
                                    id="FromTime"
                                    name="FromTime"
                                    value={ele?.FromTime}
                                    className="form-control"
                                    step="1"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                  />
                                </div>
                                <div className="mt-1">
                                  {/* <TimePicker   name="InterviewTime" /> */}
                                  <input
                                    type="time"
                                    id="ToTime"
                                    value={ele?.ToTime}
                                    name="ToTime"
                                    className="form-control"
                                    step="1"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                  />
                                </div>
                              </td>

                              {/** Date act start send */}
                              <td style={{ minWidth: "160px" }}>
                                <div style={{ marginBottom: "0.5rem" }}>
                                  <CustomDatePicker
                                    style={{
                                      width: "100%",
                                      border: errors?.[
                                        `projectmember[${index}].FromDate`
                                      ]
                                        ? "1px solid #dc3545"
                                        : "1px solid #ced4da",
                                      borderRadius: "4px",
                                      padding: "0.375rem 0.75rem",
                                    }}
                                    placeholderText="From Date"
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    name="FromDate"
                                    value={ele?.FromDate || null}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].FromDate`
                                  ] && (
                                    <div
                                      style={{
                                        color: "#dc3545",
                                        fontSize: "0.875rem",
                                        marginTop: "0.25rem",
                                      }}
                                    >
                                      {
                                        errors[
                                          `projectmember[${index}].FromDate`
                                        ]
                                      }
                                    </div>
                                  )}
                                </div>

                                <div style={{ marginBottom: "0.5rem" }}>
                                  <CustomDatePicker
                                    style={{
                                      width: "100%",
                                      border: errors?.[
                                        `projectmember[${index}].ToDate`
                                      ]
                                        ? "1px solid #dc3545"
                                        : "1px solid #ced4da",
                                      borderRadius: "4px",
                                      padding: "0.375rem 0.75rem",
                                    }}
                                    placeholderText="End Date"
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    name="ToDate"
                                    value={ele?.ToDate || null}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].ToDate`
                                  ] && (
                                    <div
                                      style={{
                                        color: "#dc3545",
                                        fontSize: "0.875rem",
                                        marginTop: "0.25rem",
                                      }}
                                    >
                                      {errors[`projectmember[${index}].ToDate`]}
                                    </div>
                                  )}
                                </div>

                                <div>
                                  <CustomDatePicker
                                    style={{
                                      width: "100%",
                                      border: errors?.[
                                        `projectmember[${index}].ActualEndDate`
                                      ]
                                        ? "1px solid #dc3545"
                                        : "1px solid #ced4da",
                                      borderRadius: "4px",
                                      padding: "0.375rem 0.75rem",
                                    }}
                                    placeholderText="Act. End Date"
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    name="ActualEndDate"
                                    value={ele?.ActualEndDate || null}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].ActualEndDate`
                                  ] && (
                                    <div
                                      style={{
                                        color: "#dc3545",
                                        fontSize: "0.875rem",
                                        marginTop: "0.25rem",
                                      }}
                                    >
                                      {
                                        errors[
                                          `projectmember[${index}].ActualEndDate`
                                        ]
                                      }
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/** invoice rate frequnecy  */}
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].InvoiceRate`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Invoice Rate"
                                    name="InvoiceRate"
                                    value={ele?.InvoiceRate}
                                  />
                                </div>
                                <div>
                                  <Select
                                    options={frequencyOptions}
                                    value={frequencyOptions?.find(
                                      (o) => o.value === ele?.InvoiceBasedOn_236
                                    )}
                                    name="InvoiceBasedOn_236"
                                    menuPortalTarget={document.body}
                                    placeholder="Freq"
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].InvoiceBasedOn_236`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].InvoiceBasedOn_236`
                                  ] ? (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].InvoiceBasedOn_236`
                                        ]
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div></div>
                              </td>

                              {/** in% incentves frequency  */}

                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].IncentiveInPercent`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Inc.%"
                                    name="IncentiveInPercent"
                                    value={ele?.IncentiveInPercent}
                                    disabled={
                                      disabledIncentiveFields[index] || false
                                    }
                                  />
                                  <div>
                                    {errors?.[
                                      `projectmember[${index}].IncentiveInPercent`
                                    ] && (
                                      <span className="error">
                                        {
                                          errors?.[
                                            `projectmember[${index}].IncentiveInPercent`
                                          ]
                                        }
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="mb-1">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].IncentiveInAmount`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Incentive"
                                    name="IncentiveInAmount"
                                    value={ele?.IncentiveInAmount}
                                    // disabled={
                                    //   disabledIncentiveFields[index] || false
                                    // }
                                  />
                                  <div>
                                    {errors?.[
                                      `projectmember[${index}].IncentiveInAmount`
                                    ] && (
                                      <span className="error">
                                        {
                                          errors?.[
                                            `projectmember[${index}].IncentiveInAmount`
                                          ]
                                        }
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="mb-1">
                                  <Select
                                    options={frequencyOptions}
                                    value={frequencyOptions?.find(
                                      (o) =>
                                        o.value === ele?.IncentiveFrequency_248
                                    )}
                                    name="IncentiveFrequency_248"
                                    menuPortalTarget={document.body}
                                    placeholder="Select Inc. App."
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].IncentiveFrequency_248`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                              </td>

                              {/** poc nam email no */}

                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].POCName`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="POC Name"
                                    name="POCName"
                                    value={ele?.POCName}
                                    disabled={
                                      disabledIncentiveFields[index] || false
                                    }
                                  />
                                </div>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].POCEmail`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="POC Email"
                                    name="POCEmail"
                                    value={ele?.POCEmail}
                                  />
                                </div>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].POCPhone`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="POC Phone"
                                    name="POCPhone"
                                    value={ele?.POCPhone}
                                  />
                                </div>
                              </td>
                              {/** Addree city state */}
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].AddressLine1`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Address1"
                                    name="AddressLine1"
                                    value={ele?.AddressLine1}
                                  />
                                </div>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[`projectmember[${index}].City`]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="City"
                                    name="City"
                                    value={ele?.City}
                                  />
                                </div>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].Country`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Country"
                                    name="Country"
                                    value={ele?.Country}
                                  />
                                </div>
                              </td>
                              {/** Addree city country zipcode */}
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].AddressLine2`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Address 2"
                                    name="AddressLine2"
                                    value={ele?.AddressLine2}
                                  />
                                </div>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[`projectmember[${index}].State`]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="State"
                                    name="State"
                                    value={ele?.State}
                                  />
                                </div>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].ZipCode`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Zip Code"
                                    name="ZipCode"
                                    value={ele?.ZipCode}
                                  />
                                </div>
                              </td>

                              <td
                                className="text-center align-middle"
                                style={{ width: "80px" }}
                              >
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                  <div className="mb-1">
                                    <i
                                      className={`bi bi-trash icons ${
                                        ele?.isNew == true
                                          ? ""
                                          : "disabled-icon"
                                      }`.trim()}
                                      onClick={() =>
                                        handleDeleteAddResource(index)
                                      }
                                    ></i>
                                  </div>
                                  <div>
                                    <i
                                      className={`bi bi-pencil-square icons ${
                                        editingIndex === index
                                          ? "disabled-icon"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        editingIndex !== index &&
                                        handleResourceEdit(index)
                                      }
                                      style={{
                                        cursor:
                                          editingIndex === index
                                            ? "not-allowed"
                                            : "pointer",
                                        opacity:
                                          editingIndex === index ? 0.5 : 1,
                                      }}
                                    />
                                  </div>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      name="TNEInvoice"
                                      className="form-check-input"
                                      checked={ele?.TNEInvoice == 1}
                                      onChange={(e) =>
                                        handleResourceChange(e, index)
                                      }
                                    />
                                    <label className="form-check-label small">
                                      TnE
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="  tab-pane fade show  p-2"
                id="addresource"
                role="tabpanel"
                aria-labelledby="addresource-tab"
                // style={{height:"700px"}}
              >
                <div className="mt-2" style={{ zIndex: "-999 !important" }}>
                  <div
                    style={{
                      overflowX: "auto", // Enables horizontal scrolling
                      whiteSpace: "nowrap", // Prevents text from wrapping
                      maxWidth: "100%", // Ensures it does not exceed the container width
                    }}
                  >
                    <button
                      type="button"
                      className="scroll-btn scroll-to-bottom"
                      onClick={() => {
                        const el = document.getElementById("forJumptoUp");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                      }}
                      style={{
                        position: "fixed",
                        top: "70px",
                        right: "20px",
                        zIndex: "1000",
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#27568B",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                        transition: "all 0.3s ease",
                        fontSize: "20px",
                      }}
                    >
                      <i className="bi bi-arrow-down"></i>
                    </button>
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                      <div className="d-flex flex-wrap align-items-center gap-3">
                        {/* Client Info */}
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            Client:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientNameOptions?.find(
                                  (o) => o.value === formData?.ClientID
                                )?.label || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={
                                clientNameOptions?.find(
                                  (o) => o.value === formData?.ClientID
                                )?.label || "N/A"
                              }
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        {/* Contact Points */}
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">CP:</label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.CP_Name || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.CP_Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">DP:</label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.DP_Name || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.DP_Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">PM:</label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.PM_Name || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.PM_Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            RMG POC:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {clientFetchData[0]?.ROMPOCName || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={clientFetchData[0]?.ROMPOCName || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>
                        {/* Project Info */}
                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            Project Name:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>{formData?.Name || "N/A"}</Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={formData?.Name || "N/A"}
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>

                        <div className="d-flex flex-column">
                          <label className="form-label small mb-1">
                            Project Type:
                          </label>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {projectTypeOptions?.find(
                                  (o) => o.value === formData?.ProjectType
                                )?.label || "N/A"}
                              </Tooltip>
                            }
                          >
                            <input
                              className="form-control form-control-sm"
                              value={
                                projectTypeOptions?.find(
                                  (o) => o.value === formData?.ProjectType
                                )?.label || "N/A"
                              }
                              readOnly
                              disabled
                            />
                          </OverlayTrigger>
                        </div>
                      </div>

                      {/* Add Button */}
                      <div className="d-flex align-items-center">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Add new resource</Tooltip>}
                        >
                          <button
                            type="button"
                            onClick={handleAddResourceLine}
                            className="custom-btn-sm  mt-4 pull-right"
                          >
                            <i className="fa fa-plus fs-6"></i>
                            <span>Add</span>
                          </button>
                        </OverlayTrigger>
                      </div>
                    </div>

                    <div
                      className="table-responsive poc-head rounded px-2"
                      style={{ height: "auto" }}
                    >
                      <Table
                        style={{
                          background: "#ECECEC",
                          minWidth: "1200px", // Set a minimum width to ensure the table is scrollable
                        }}
                        className="table table-bordered"
                      >
                        <thead id="thcolor" className="sticky-thead">
                          <tr className="text-center">
                            <th>Sr. No.</th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                SOW/PO/SO #
                                <span className="text-danger">*</span>
                              </div>
                              <div>Allocation</div>
                            </th>

                            <th>
                              Employee<span className="text-danger">*</span>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Role<span className="text-danger">*</span>
                              </div>
                              <div>
                                Technology
                                <span className="text-danger">*</span>
                              </div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Location<span className="text-danger">*</span>
                              </div>
                              <div>
                                Loc. Type
                                <span className="text-danger">*</span>
                              </div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Invoice Rate
                              </div>
                              <div>
                                Freq<span className="text-danger">*</span>
                              </div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                From Date
                                <span className="text-danger">*</span>
                              </div>
                              <div>To Date</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Inc. App.
                                <span className="text-danger">*</span>
                              </div>
                              <div>Extended On</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Inc. %<span className="text-danger">*</span>
                              </div>
                              <div>Extended To</div>
                            </th>
                            <th className="border-1 px-0">
                              <div className="border-1 border-bottom">
                                Qtly Inc. Amt.
                                <span className="text-danger">*</span>
                              </div>
                              <div>Act. End</div>
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData?.projectmember?.map((ele, index) => (
                            <tr className="text-center" key={index}>
                              <td
                                className="text-center"
                                style={{ minWidth: "50px" }}
                              >
                                {index + 1}
                              </td>
                              <td
                                style={{ minWidth: "200px" }}
                                className="text-center align-middle"
                              >
                                <div className="d-flex flex-column align-items-center gap-1">
                                  {/* Select Dropdown for ProjectInvoiceDetailID */}
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "ProjectInvoiceDetailID",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column ===
                                      "ProjectInvoiceDetailID" ? (
                                      <Select
                                        name="ProjectInvoiceDetailID"
                                        value={projectInvoiceNoOptions?.find(
                                          (o) =>
                                            o.value ===
                                            ele?.ProjectInvoiceDetailID
                                        )}
                                        placeholder="Select SOW/PO/SO"
                                        options={projectInvoiceNoOptions}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );
                                          setEditingIndex(null);
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        className={`${
                                          errors?.[
                                            `projectmember[${index}].ProjectInvoiceDetailID`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "200px", // ✅ Set dropdown width
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          menu: (base) => ({
                                            ...base,
                                            width: "270px", // ✅ Match menu width
                                            maxWidth: "80vw",
                                            position: "absolute",
                                            left: 0,
                                          }),
                                          menuList: (base) => ({
                                            ...base,
                                            maxHeight: "300px",
                                          }),
                                          option: (base) => ({
                                            ...base,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <div className="p-2 w-100 text-center">
                                        {projectInvoiceNoOptions?.find(
                                          (o) =>
                                            o.value ===
                                            ele?.ProjectInvoiceDetailID
                                        )?.label || "Select SOW"}
                                      </div>
                                    )}

                                    {errors?.[
                                      `projectmember[${index}].ProjectInvoiceDetailID`
                                    ] && (
                                      <div className="text-danger small mt-1">
                                        {
                                          errors[
                                            `projectmember[${index}].ProjectInvoiceDetailID`
                                          ]
                                        }
                                      </div>
                                    )}
                                  </div>

                                  {/* Select Dropdown for AllocationPercent */}
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "AllocationPercent",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column ===
                                      "AllocationPercent" ? (
                                      <Select
                                        name="AllocationPercent"
                                        value={allocationPercentOptions?.find(
                                          (o) =>
                                            o.value === ele?.AllocationPercent
                                        )}
                                        placeholder="Utilization Percentage"
                                        options={allocationPercentOptions}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );
                                          setEditingIndex(null);
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        className={`${
                                          errors?.[
                                            `projectmember[${index}].AllocationPercent`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "200px",
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <a
                                        className="p-2 w-100 text-center"
                                        style={{ textDecoration: "none" }}
                                      >
                                        {allocationPercentOptions?.find(
                                          (o) =>
                                            o.value === ele?.AllocationPercent
                                        )?.label || "Utilization Percentage"}
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </td>

                              <td
                                style={{ minWidth: "160px" }}
                                className="text-center align-middle"
                              >
                                <div className="d-flex flex-column align-items-center">
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      setEditingIndex({
                                        row: index,
                                        column: "EmployeeID",
                                      })
                                    }
                                  >
                                    {editingIndex?.row === index &&
                                    editingIndex?.column === "EmployeeID" ? (
                                      <Select
                                        className={`mb-1 ${
                                          errors?.[
                                            `projectmember[${index}].EmployeeID`
                                          ]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        placeholder={"Select Employee"}
                                        name="EmployeeID"
                                        options={employeelistOptions}
                                        value={employeelistOptions?.find(
                                          (o) => o.value === ele?.EmployeeID
                                        )}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption, action) => {
                                          handleResourceSelect(
                                            selectedOption,
                                            index,
                                            action.name
                                          );
                                          setSelectedEmpID(
                                            selectedOption.value
                                          );
                                          fetchEmployeeDetails(
                                            selectedOption.value
                                          );
                                          setEditingIndex(null); // Close editor after selection
                                        }}
                                        autoFocus
                                        onBlur={() => setEditingIndex(null)}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "32px",
                                            height: "32px",
                                            width: "200px",
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          dropdownIndicator: (base) => ({
                                            ...base,
                                            padding: "4px",
                                          }),
                                        }}
                                      />
                                    ) : (
                                      <div className=" text-center">
                                        {employeelistOptions?.find(
                                          (o) => o.value === ele?.EmployeeID
                                        )?.label || "Select Employee"}
                                      </div>
                                    )}
                                  </div>
                                  {errors?.[
                                    `projectmember[${index}].EmployeeID`
                                  ] && (
                                    <span className="error text-danger small">
                                      {
                                        errors?.[
                                          `projectmember[${index}].EmployeeID`
                                        ]
                                      }
                                    </span>
                                  )}

                                  {/* Ongoing Projects link (unchanged) */}
                                  <div
                                    className="mt-3"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {ele?.EmployeeID !== "" ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="project-tooltip">
                                            Ongoing Project
                                          </Tooltip>
                                        }
                                      >
                                        <img
                                          src={gearImg}
                                          alt="Projects"
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={() => {
                                            handleProjectModal(ele?.EmployeeID);
                                            fetchEmployeeDetails(
                                              ele?.EmployeeID
                                            );
                                          }}
                                        />
                                      </OverlayTrigger>
                                    ) : null}
                                  </div>
                                </div>
                              </td>

                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    placeholder="Role"
                                    name="Role"
                                    value={ele?.Role}
                                    className={`form-control ${
                                      errors?.[`projectmember[${index}].Role`]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                  />

                                  {errors?.[`projectmember[${index}].Role`] && (
                                    <span className="error">
                                      {errors?.[`projectmember[${index}].Role`]}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <Select
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].technologyTypeList`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Select Technology"
                                    options={matchedTechnologyOpt}
                                    value={matchedTechnologyOpt?.find(
                                      (o) => o.value === ele?.technologyTypeList
                                    )}
                                    name="technologyTypeList"
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].technologyTypeList`
                                  ] ? (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].technologyTypeList`
                                        ]
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <Select
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].Location`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Select Location"
                                    options={locationOptions}
                                    value={locationOptions?.find(
                                      (o) => o.value === Number(ele?.Location)
                                    )}
                                    name="Location"
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].Location`
                                  ] ? (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].Location`
                                        ]
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div>
                                  <Select
                                    options={locationTypeOptions}
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].LocationType_237`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Select Loc"
                                    value={locationTypeOptions?.find(
                                      (o) =>
                                        o.value ===
                                        Number(ele?.LocationType_237)
                                    )}
                                    name="LocationType_237"
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].LocationType_237`
                                  ] ? (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].LocationType_237`
                                        ]
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="number"
                                    className={`form-control ${
                                      errors?.[
                                        `projectmember[${index}].InvoiceRate`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Invoice Rate"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    name="InvoiceRate"
                                    value={ele?.InvoiceRate}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].InvoiceRate`
                                  ] && (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].InvoiceRate`
                                        ]
                                      }
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <Select
                                    options={frequencyOptions}
                                    value={frequencyOptions?.find(
                                      (o) =>
                                        o.value ===
                                          Number(ele?.InvoiceBasedOn_236) || 0
                                    )}
                                    placeholder="Select Freq"
                                    name="InvoiceBasedOn_236"
                                    menuPortalTarget={document.body}
                                    onChange={(selectedOption) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        "InvoiceBasedOn_236"
                                      )
                                    }
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].InvoiceBasedOn_236`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].InvoiceBasedOn_236`
                                  ] && (
                                    <span className="error">
                                      {
                                        errors[
                                          `projectmember[${index}].InvoiceBasedOn_236`
                                        ]
                                      }
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <CustomDatePicker
                                    className={`form-control ${
                                      errors?.FromDate ? "is-invalid" : ""
                                    }`}
                                    placeholderText=" From Date"
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    name="FromDate"
                                    value={ele?.FromDate || null}
                                  />
                                  <div>
                                    {errors?.[
                                      `projectmember[${index}].FromDate`
                                    ] && (
                                      <span className="error">
                                        {
                                          errors?.[
                                            `projectmember[${index}].FromDate`
                                          ]
                                        }
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div>
                                  <CustomDatePicker
                                    className={`form-control ${
                                      errors?.ToDate ? "is-invalid" : ""
                                    }`}
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    placeholderText=" To Date"
                                    name="ToDate"
                                    value={ele?.ToDate || null}
                                  />
                                  <div>
                                    {errors?.[
                                      `projectmember[${index}].ToDate`
                                    ] && (
                                      <span className="error">
                                        {
                                          errors?.[
                                            `projectmember[${index}].ToDate`
                                          ]
                                        }
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <Select
                                    options={incentiveOptions}
                                    value={incentiveOptions?.find(
                                      (o) =>
                                        o.value === ele?.IncentiveApplicable
                                    )}
                                    name="IncentiveApplicable"
                                    menuPortalTarget={document.body}
                                    placeholder="Select Inc. App."
                                    onChange={(selectedOption, action) =>
                                      handleResourceSelect(
                                        selectedOption,
                                        index,
                                        action.name
                                      )
                                    }
                                    className={` ${
                                      errors?.[
                                        `projectmember[${index}].IncentiveApplicable`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].IncentiveApplicable`
                                  ] ? (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].IncentiveApplicable`
                                        ]
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div>
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    readOnly={
                                      editingIndex !== index ? true : false
                                    }
                                    placeholderText="Extended On"
                                    value={ele?.ExtendedOn || null}
                                    name="ExtendedOn"
                                    className="form-control"
                                  />
                                </div>
                              </td>
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].IncentiveInPercent`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    placeholder="Inc.%"
                                    name="IncentiveInPercent"
                                    value={ele?.IncentiveInPercent}
                                    disabled={
                                      disabledIncentiveFields[index] || false
                                    }
                                  />
                                  {errors?.[
                                    `projectmember[${index}].IncentiveInPercent`
                                  ] && (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].IncentiveInPercent`
                                        ]
                                      }
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <CustomDatePicker
                                    placeholderText="Extended To"
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    className="form-control"
                                    readOnly={
                                      editingIndex !== index ? true : false
                                    }
                                    name="ExtendedTo"
                                    value={ele?.ExtendedTo || null}
                                  />
                                </div>
                              </td>
                              <td style={{ minWidth: "160px" }}>
                                <div className="mb-1">
                                  <input
                                    type="number"
                                    placeholder="Inc.Amt."
                                    onChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    name="IncentiveInAmount"
                                    className={`form-control text-end ${
                                      errors?.[
                                        `projectmember[${index}].IncentiveInAmount`
                                      ]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    value={ele?.IncentiveInAmount}
                                  />
                                  {errors?.[
                                    `projectmember[${index}].IncentiveInAmount`
                                  ] && (
                                    <span className="error">
                                      {
                                        errors?.[
                                          `projectmember[${index}].IncentiveInAmount`
                                        ]
                                      }
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResourceChange(e, index)
                                    }
                                    placeholderText=" Actual End Date"
                                    name="ActualEndDate"
                                    className="form-control"
                                    value={ele?.ActualEndDate || null}
                                    minDate={
                                      new Date(
                                        new Date().setDate(
                                          new Date().getDate() - 15
                                        )
                                      )
                                    }
                                  />
                                </div>
                              </td>
                              <td
                                className="text-center align-middle"
                                style={{ minWidth: "60px" }}
                              >
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                  <div className="mb-1">
                                    <i
                                      className={`bi bi-trash icons ${
                                        ele?.isNew == true
                                          ? ""
                                          : "disabled-icon"
                                      }`.trim()}
                                      onClick={() =>
                                        handleDeleteAddResource(index)
                                      }
                                    ></i>
                                  </div>
                                  <div>
                                    <i
                                      className={`bi bi-pencil-square icons ${
                                        editingIndex === index
                                          ? "disabled-icon"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        editingIndex !== index &&
                                        handleResourceEdit(index)
                                      }
                                      style={{
                                        cursor:
                                          editingIndex === index
                                            ? "not-allowed"
                                            : "pointer",
                                        opacity:
                                          editingIndex === index ? 0.5 : 1,
                                      }}
                                    />
                                  </div>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      name="TNEInvoice"
                                      className="form-check-input"
                                      checked={ele?.TNEInvoice == 1}
                                      onChange={(e) =>
                                        handleResourceChange(e, index)
                                      }
                                    />
                                    <label className="form-check-label small">
                                      TnE
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/** LEcay Resoruce  */}
            <div
              className="tab-pane fade show  p-2"
              id="oldResources"
              role="tabpanel"
              aria-labelledby="oldResources-tab"
              style={{ height: "auto" }}
            >
              <div className="mt-2" style={{ zIndex: "-999 !important" }}>
                <div
                  className="table-responsive rounded px-2"
                  style={{ height: "auto" }}
                >
                  <Table
                    style={{
                      background: "#ECECEC",
                      minWidth: "1200px",
                    }}
                    striped
                    className="table table-bordered"
                  >
                    <thead id="thcolor" className="sticky-thead">
                      <tr className="text-center">
                        <th>Sr. No.</th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">
                            SOW/PO/SO #
                          </div>
                          <div>Allocation</div>
                        </th>
                        <th>Employee</th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">RoleList</div>
                          <div>Technology</div>
                        </th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">Location</div>
                          <div>Loc. Type</div>
                        </th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">
                            Invoice Rate
                          </div>
                          <div>Freq</div>
                        </th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">
                            From Date
                          </div>
                          <div>To Date</div>
                        </th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">
                            Inc. App.
                          </div>
                          <div>Extended On</div>
                        </th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">Inc. %</div>
                          <div>Extended To</div>
                        </th>
                        <th className="border-1 px-0">
                          <div className="border-1 border-bottom">
                            Qtly Inc. Amt.
                          </div>
                          <div>Act. End</div>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {oldResourcesArr?.map((ele, index) => (
                        <tr className="text-center" key={index}>
                          <td
                            className="text-center border-1 border-bottom"
                            style={{ width: "100px" }}
                          >
                            {index + 1}
                          </td>

                          <td
                            className="text-center align-middle"
                            style={{ width: "130px" }}
                          >
                            <div className="d-flex flex-column align-items-center gap-1">
                              <div className="w-100 border-1 border-bottom">
                                {
                                  projectInvoiceNoOptions?.find(
                                    (o) =>
                                      o.value === ele?.ProjectInvoiceDetailID
                                  )?.label
                                }
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  id={`tne-invoice-${index}`}
                                  className="form-check-input"
                                  checked={
                                    ele?.TNEInvoice == "1" ? true : false
                                  }
                                  onChange={(e) =>
                                    handleResourceChange(e, index)
                                  }
                                  readOnly
                                  disabled
                                />
                                <label
                                  htmlFor={`tne-invoice-${index}`}
                                  className="form-check-label small"
                                >
                                  TnE Invoice
                                </label>
                              </div>
                            </div>
                          </td>

                          <td
                            className="text-center align-middle"
                            style={{ width: "130px" }}
                          >
                            <div className="border-1 border-bottom">
                              {ele?.EmployeeName}
                            </div>
                            <div>
                              <a
                                href="#"
                                style={{ textDecoration: "none" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProjectModal(ele?.EmployeeID);
                                  fetchEmployeeDetails(ele?.EmployeeID);
                                }}
                              >
                                Ongoing Projects
                              </a>
                            </div>
                          </td>

                          <td style={{ width: "130px" }}>
                            <div className="mb-1 border-1 border-bottom">
                              {ele?.Role}
                            </div>
                            <div>
                              {
                                matchedTechnologyOpt?.find(
                                  (o) => o.value === ele?.technologyTypeList
                                )?.label
                              }
                            </div>
                          </td>

                          <td style={{ width: "130px" }}>
                            <div className="border-1 border-bottom mb-1">
                              {
                                locationOptions?.find(
                                  (o) => o.value === Number(ele?.Location)
                                )?.label
                              }
                            </div>
                            <div>
                              {
                                locationTypeOptions?.find(
                                  (o) =>
                                    o.value === Number(ele?.LocationType_237)
                                )?.label
                              }
                            </div>
                          </td>

                          <td style={{ width: "130px" }}>
                            <div className="border-1 border-bottom mb-1">
                              {ele?.InvoiceRate}
                            </div>
                            <div>
                              {
                                frequencyOptions?.find(
                                  (o) =>
                                    o.value === Number(ele?.InvoiceBasedOn_236)
                                )?.label
                              }
                            </div>
                          </td>

                          <td style={{ width: "163px" }}>
                            <div className="border-1 border-bottom mb-1">
                              {ele?.FromDate &&
                                moment(ele?.FromDate).format("DD-MMM-YYYY")}
                            </div>
                            <div>
                              {ele?.ToDate &&
                                moment(ele?.ToDate).format("DD-MMM-YYYY")}
                            </div>
                          </td>

                          <td style={{ width: "163px" }}>
                            <div className="border-1 border-bottom mb-1">
                              {
                                incentiveOptions?.find(
                                  (o) => o.value === ele?.IncentiveApplicable
                                )?.label
                              }
                            </div>
                            <div>
                              {ele?.ExtendedOn &&
                                moment(ele?.ExtendedOn).format("DD-MMM-YYYY")}
                            </div>
                          </td>

                          <td style={{ width: "163px" }}>
                            <div className="border-1 border-bottom mb-1">
                              {ele?.IncentiveInPercent}
                            </div>
                            <div>
                              {ele?.ExtendedTo &&
                                moment(ele?.ExtendedTo).format("DD-MMM-YYYY")}
                            </div>
                          </td>

                          <td style={{ width: "163px" }}>
                            <div className="border-1 border-bottom mb-1">
                              {ele?.IncentiveInAmount}
                            </div>
                            <div>
                              {ele?.ActualEndDate
                                ? moment(ele?.ActualEndDate).format(
                                    "DD-MMM-YYYY"
                                  )
                                : moment(ele?.ToDate).format("DD-MMM-YYYY")}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <div className="pb-2">
              <div className="text-end me-2">
                <button
                  type="button"
                  id="forJumptoUp"
                  className="cancel-btn me-2"
                  onClick={() => {
                    navigate("/create-project");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading ? true : false}
                  className="custom-btn me-2"
                  // onClick={handleSubmit}
                >
                  {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
          {/* button code start*/}

          <button
            type="button"
            className="back-to-top-btn"
            onClick={() => {
              const el = document.getElementById("myTabContent");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            style={{
              position: "fixed",
              bottom: "40px",
              right: "20px",
              zIndex: 1000,
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "#27568B",
              color: "white",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
              transition: "all 0.3s ease",
              fontSize: "20px",
            }}
          >
            <i className="bi bi-arrow-up"></i>
          </button>
          {/* button code end*/}
        </form>
        {/** Fixed BID Modal */}
        <Modal
          show={showFixedBidModal}
          onHide={handleFixedBidClose}
          dialogClassName="modal-xl"
          centered
        >
          <div
            className="modal-content"
            style={{ borderRadius: "8px", zoom: 0.7 }}
          >
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px 8px 0 0",
                padding: "12px 16px",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2F2E4B",
                  margin: "0",
                }}
              >
                Add Milestone Details
              </p>
              <button
                onClick={handleFixedBidClose}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#000",
                  padding: "4px",
                  borderRadius: "4px",
                  transition: "all 0.2s",
                  lineHeight: "1",
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <Modal.Body style={{ padding: "16px", backgroundColor: "white" }}>
              <div className="d-flex justify-content-end mb-3">
                <button
                  type="button"
                  onClick={handleFixedBidAddLine}
                  className="custom-btn"
                  style={{
                    padding: "6px 12px",
                    fontSize: "14px",
                  }}
                >
                  <i className="fa fa-plus"></i>&nbsp;Add
                </button>
              </div>

              <div
                className="table-responsive"
                style={{ borderRadius: "4px", border: "1px solid #e9ecef" }}
              >
                <Table bordered hover style={{ marginBottom: "0" }}>
                  <thead style={{ backgroundColor: "#f8f9fa" }}>
                    <tr>
                      <th style={{ padding: "10px", fontWeight: "600" }}>##</th>
                      <th style={{ padding: "10px", fontWeight: "600" }}>
                        Milestone<span className="text-danger">*</span>
                      </th>
                      <th style={{ padding: "10px", fontWeight: "600" }}>
                        End Date
                      </th>
                      <th style={{ padding: "10px", fontWeight: "600" }}>
                        Milestone Value
                      </th>
                      <th style={{ padding: "10px", fontWeight: "600" }}>
                        Remarks
                      </th>
                      <th style={{ padding: "10px", fontWeight: "600" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {fixesBidLines?.map((ele, index) => (
                      <tr key={index}>
                        <td
                          style={{ padding: "10px", verticalAlign: "middle" }}
                        >
                          {index + 1}
                        </td>
                        <td style={{ padding: "10px" }}>
                          <input
                            type="text"
                            className="form-control"
                            name="Milestone"
                            value={ele?.Milestone}
                            onChange={(e) => handleMileStoneChange(e, index)}
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                        </td>
                        <td style={{ padding: "10px" }}>
                          <CustomDatePicker
                            className="form-control"
                            name="EndDate"
                            value={ele?.EndDate || null}
                            placeholderText="DD-MMM-YYYY"
                            handleChange={(e) =>
                              handleMileStoneChange(e, index)
                            }
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                        </td>
                        <td style={{ padding: "10px" }}>
                          <input
                            type="text"
                            className="form-control"
                            name="MilestoneValue"
                            value={ele?.MilestoneValue}
                            onChange={(e) => handleMileStoneChange(e, index)}
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                        </td>
                        <td style={{ padding: "10px" }}>
                          <input
                            type="text"
                            className="form-control"
                            name="Remarks"
                            value={ele?.Remarks}
                            onChange={(e) => handleMileStoneChange(e, index)}
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                        >
                          <i
                            className={
                              ele?.ID
                                ? "bi bi-trash icons disabled-icon"
                                : "bi bi-trash icons"
                            }
                            onClick={() => {
                              if (ele?.ID) {
                                handleDeleteMilestoneLine(index);
                              }
                            }}
                            style={{
                              cursor: ele?.ID ? "not-allowed" : "pointer",
                              color: ele?.ID ? "#000" : "#000",
                              fontSize: "16px",
                            }}
                          ></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="mt-2">
                {milestoneErrors?.Milestone && (
                  <p className="text-danger" style={{ fontSize: "14px" }}>
                    Milestone Detail Entries: {milestoneErrors.Milestone}
                  </p>
                )}
              </div>
            </Modal.Body>

            <div
              className="modal-footer"
              style={{
                padding: "12px 16px",
                borderTop: "1px solid #f0f0f0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="cancel-btn"
                onClick={handleFixedBidClose}
                style={{
                  padding: "6px 12px",
                  marginRight: "8px",
                }}
              >
                Cancel
              </button>
              <button
                disabled={loading ? true : false}
                className="custom-btn"
                onClick={addMilestoneToInvoice}
                style={{
                  padding: "6px 12px",
                }}
              >
                {loading ? <FaSpinner className="sm-spinner" /> : "Add"}
              </button>
            </div>
          </div>
        </Modal>
        {/** SOW Modal */}
        <Modal
          show={showSOWModal}
          onHide={handleSOWClose}
          dialogClassName="modal-xl"
          centered
        >
          <div
            className="modal-content"
            style={{ borderRadius: "8px", zoom: 0.7 }}
          >
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px 8px 0 0",
                padding: "12px 16px",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2F2E4B",
                  margin: "0",
                }}
              >
                Add Details
              </p>
              <button
                onClick={handleSOWClose}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#000",
                  padding: "4px",
                  borderRadius: "4px",
                  transition: "all 0.2s",
                  lineHeight: "1",
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <Modal.Body style={{ padding: "16px", backgroundColor: "white" }}>
              {/* Fixed header section */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div style={{ fontSize: "15px", fontWeight: "500" }}>
                  <strong style={{ color: "#495057" }}>PO Value: </strong>
                  <span style={{ color: "#27568B" }}>
                    {formData?.POValue || "-"}
                  </span>
                </div>
                <button
                  type="button"
                  onClick={handleSowAddLine}
                  className="custom-btn"
                  style={{
                    padding: "6px 12px",
                    fontSize: "14px",
                  }}
                >
                  <i className="fa fa-plus"></i>&nbsp;Add
                </button>
              </div>

              {/* Scrollable table section */}
              <div
                className="table-responsive rounded"
                style={{
                  border: "1px solid #e9ecef",
                  maxHeight: "60vh",
                  overflowY: "auto",
                }}
              >
                <Table bordered hover style={{ marginBottom: "0" }}>
                  <thead
                    style={{
                      backgroundColor: "#f8f9fa",
                      position: "sticky",
                      top: 0,
                      zIndex: 12,
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "40px",
                        }}
                      >
                        ##
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Type
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "300px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        SOW/PO/SO<span className="text-danger">*</span>
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "160px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Start Date<span className="text-danger">*</span>
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "160px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        End Date
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        PO Value
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        PO Balance
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "150px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Remarks
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          minWidth: "50px",
                        }}
                      ></th>
                    </tr>
                  </thead>

                  <tbody>
                    {sowLines?.map((ele, index) => (
                      <tr key={index}>
                        <td
                          style={{ padding: "10px", verticalAlign: "middle" }}
                        >
                          {index + 1}
                        </td>

                        {/* Type Select */}
                        <td style={{ padding: "10px", minWidth: "120px" }}>
                          <Select
                            options={sowTypesOptions}
                            menuPortalTarget={document.body}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "32px",
                                borderRadius: "4px",
                                borderColor: errors?.[
                                  `sowLines[${index}].ProposalType`
                                ]
                                  ? "#dc3545"
                                  : "#ced4da",
                              }),
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            name="ProposalType"
                            value={sowTypesOptions?.find(
                              (o) => o.value === ele?.ProposalType
                            )}
                            isDisabled={ele?.ID ? true : false}
                            onChange={(selectedOption, action) =>
                              handleProjectInvoiceSelectChange(
                                selectedOption,
                                action.name,
                                index
                              )
                            }
                          />
                        </td>

                        {/* Invoice No */}
                        <td style={{ padding: "10px", minWidth: "120px" }}>
                          <input
                            type="text"
                            className={`form-control ${
                              errors?.[`sowLines[${index}].InvoiceNo`]
                                ? "is-invalid"
                                : ""
                            }`}
                            name="InvoiceNo"
                            disabled={ele?.ID ? true : false}
                            value={ele?.InvoiceNo}
                            onChange={(e) =>
                              handleProjectInvoiceChange(e, index)
                            }
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                          {errors?.[`sowLines[${index}].InvoiceNo`] && (
                            <div
                              className="invalid-feedback d-block"
                              style={{ fontSize: "12px" }}
                            >
                              {errors[`sowLines[${index}].InvoiceNo`]}
                            </div>
                          )}
                        </td>

                        {/* Start Date */}
                        <td style={{ padding: "10px", minWidth: "160px" }}>
                          <CustomDatePicker
                            placeholderText="DD-MMM-YYYY"
                            name="StartDate"
                            readOnly={ele?.ID ? true : false}
                            className={`form-control ${errors?.[`sowLines[${index}].StartDate`]
                              ? "is-invalid"
                              : ""
                              }`}
 popperClassName="zindex-1000-datepicker"
  popperPlacement="bottom-start"
                            value={ele?.StartDate}
                            handleChange={(date) =>
                              handleProjectInvoiceChange(date, index)
                            }
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                          {errors?.[`sowLines[${index}].StartDate`] && (
                            <div
                              className="invalid-feedback d-block"
                              style={{ fontSize: "12px" }}
                            >
                              {errors[`sowLines[${index}].StartDate`]}
                            </div>
                          )}
                        </td>

                        {/* End Date */}
                        <td style={{ padding: "10px", minWidth: "160px" }}>
                          <CustomDatePicker
                            placeholderText="DD-MMM-YYYY"
                            name="EndDate"
                            className="form-control"
                            value={ele?.EndDate}
                            handleChange={(date) =>
                              handleProjectInvoiceChange(date, index)
                            }
                            minDate={
                              ele?.StartDate
                                ? new Date(ele?.StartDate)
                                : new Date()
                            }
                             popperClassName="zindex-1000-datepicker"
  popperPlacement="bottom-start"
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                        </td>

                        {/* PO Value */}
                        <td style={{ padding: "10px" }}>
                          <input
                            type="number"
                            className={`form-control ${
                              errors?.[`sowLines[${index}].SoPoValue`]
                                ? "is-invalid"
                                : ""
                            }`}
                            name="SoPoValue"
                            value={ele?.SoPoValue}
                            onChange={(e) =>
                              handleProjectInvoiceChange(e, index)
                            }
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                          {errors?.[`sowLines[${index}].SoPoValue`] && (
                            <div
                              className="invalid-feedback d-block"
                              style={{ fontSize: "12px" }}
                            >
                              {errors[`sowLines[${index}].SoPoValue`]}
                            </div>
                          )}
                        </td>

                        {/* PO Balance */}
                        <td style={{ padding: "10px" }}>
                          <input
                            type="number"
                            className={`form-control ${
                              errors?.[`sowLines[${index}].SoPoBalance`]
                                ? "is-invalid"
                                : ""
                            }`}
                            name="SoPoBalance"
                            value={ele?.SoPoBalance}
                            onChange={(e) =>
                              handleProjectInvoiceChange(e, index)
                            }
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                          {errors?.[`sowLines[${index}].SoPoBalance`] && (
                            <div
                              className="invalid-feedback d-block"
                              style={{ fontSize: "12px" }}
                            >
                              {errors[`sowLines[${index}].SoPoBalance`]}
                            </div>
                          )}
                        </td>

                        {/* Remarks */}
                        <td style={{ padding: "10px" }}>
                          <input
                            type="text"
                            className={`form-control ${
                              errors?.[`sowLines[${index}].SoPoRemark`]
                                ? "is-invalid"
                                : ""
                            }`}
                            name="SoPoRemark"
                            value={ele?.SoPoRemark}
                            onChange={(e) =>
                              handleProjectInvoiceChange(e, index)
                            }
                            style={{
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                            }}
                          />
                          {errors?.[`sowLines[${index}].SoPoRemark`] && (
                            <div
                              className="invalid-feedback d-block"
                              style={{ fontSize: "12px" }}
                            >
                              {errors[`sowLines[${index}].SoPoRemark`]}
                            </div>
                          )}
                        </td>

                        {/* Delete Button */}
                        <td
                          style={{
                            padding: "10px",
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                        >
                          <i
                            className={
                              ele?.ID
                                ? "bi bi-trash icons disabled-icon"
                                : "bi bi-trash icons"
                            }
                            onClick={() => {
                              if (ele?.ID) handleDeleteLine(index);
                            }}
                            style={{
                              cursor: ele?.ID ? "not-allowed" : "pointer",
                              color: ele?.ID ? "#000" : "#000",
                              fontSize: "16px",
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* Global Errors */}
              <div className="mt-3">
                {sowErrors?.InvoiceNo && (
                  <p className="text-danger" style={{ fontSize: "14px" }}>
                    Invoice Detail Entries: {sowErrors.InvoiceNo}
                  </p>
                )}
                {sowErrors?.StartDate && (
                  <p className="text-danger" style={{ fontSize: "14px" }}>
                    Invoice Detail Entries: {sowErrors.StartDate}
                  </p>
                )}
              </div>
            </Modal.Body>

            <div
              className="modal-footer"
              style={{
                padding: "12px 16px",
                borderTop: "1px solid #f0f0f0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="cancel-btn"
                onClick={handleSOWClose}
                style={{
                  padding: "6px 12px",
                  marginRight: "8px",
                }}
              >
                Cancel
              </button>
              <button
                disabled={loading || sowLines.length === 0 ? true : false}
                className="custom-btn"
                onClick={AddSowToInvoice}
                style={{
                  padding: "6px 12px",
                }}
              >
                {loading ? <FaSpinner className="sm-spinner" /> : "Add"}
              </button>
            </div>
          </div>
        </Modal>
        {/** Project Modal */}
        <Modal
          show={showProjectModal}
          onHide={handleProjectModalClose}
          dialogClassName="modal-lg"
          centered
        >
          <div className="modal-content" style={{ borderRadius: "8px" }}>
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px 8px 0 0",
                padding: "12px 16px",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2F2E4B",
                  margin: "0",
                }}
              >
                Project Details
              </p>
              <button
                onClick={handleProjectModalClose}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#000",
                  padding: "4px",
                  borderRadius: "4px",
                  transition: "all 0.2s",
                  lineHeight: "1",
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <Modal.Body
              style={{
                padding: "16px",
                backgroundColor: "white",
                maxHeight: "60vh",
                overflowY: "auto",
              }}
            >
              <div
                className="table-responsive rounded"
                style={{ border: "1px solid #e9ecef" }}
              >
                <Table hover bordered style={{ marginBottom: "0" }}>
                  <thead
                    style={{
                      backgroundColor: "#f8f9fa",
                      position: "sticky",
                      top: 0,
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          padding: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                        }}
                      >
                        Project
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          minWidth: "120px",
                        }}
                      >
                        From Date
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          minWidth: "120px",
                        }}
                      >
                        To Date
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          minWidth: "120px",
                        }}
                      >
                        Actual End Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeData.some(
                      (emp) => emp.EmployeeID === selectedEmpID
                    ) ? (
                      employeeData
                        .filter((emp) => emp.EmployeeID === selectedEmpID)
                        .flatMap((emp) => emp?.data || [])
                        .map((ele, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "12px",
                                verticalAlign: "middle",
                              }}
                            >
                              {ele?.ProjectName}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              {ele?.FromDate
                                ? moment(ele?.FromDate).format("DD-MMM-YYYY")
                                : ""}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              {ele?.ToDate
                                ? moment(ele?.ToDate).format("DD-MMM-YYYY")
                                : ""}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              {ele?.ActualEndDate
                                ? moment(ele?.ActualEndDate).format(
                                    "DD-MMM-YYYY"
                                  )
                                : ""}
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td
                          className="text-center"
                          colSpan={4}
                          style={{
                            padding: "16px",
                            color: "#6c757d",
                          }}
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Modal.Body>

            <div
              className="modal-footer"
              style={{
                padding: "12px 16px",
                borderTop: "1px solid #f0f0f0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="custom-btn"
                onClick={handleProjectModalClose}
                style={{
                  padding: "6px 12px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
};

export default CreateProjectEdit;
